import ProductsService from '../../services/ProductsService';

export default {
	namespaced: true,
	state: {
		products: [],
	},
	actions: {
		async loadProducts({commit}){
			const products = await ProductsService.fetch();
			commit('setProducts', products);
		},
	},
	mutations: {
		setProducts(state, payload) {
			state.products = payload;
		}
	}
}
